/** 항목을 순서대로 하나씩 보낸다(옛 화면처럼 행별 순차 반영). 실패하면 그 자리에서 멈추고, 앞서 끝난 건수를 오류의 done 에 실어 다시 던진다. */
export const inOrder = <T>(items: T[], send: (item: T) => Promise<unknown>): Promise<number> =>
  items.reduce<Promise<number>>(
    (prev, item) => prev.then((done) => send(item).then(() => done + 1, (e: Error) => Promise.reject(Object.assign(e, { done })))),
    Promise.resolve(0),
  )
